export default {
  signedOut: "Você saiu com sucesso",
  session: {
    expired: "Sessão expirada",
    expiredDescription: "Você foi desconectado por inatividade"
  },
  signOutSuccess: "Saída realizada com sucesso",
  signOutSuccessDescription: "Você foi desconectado com sucesso.",
  signOutFailed: "Falha ao sair",
  signOutFailedDescription: "Ocorreu um erro ao sair da conta.",
  signInSuccess: "Login realizado com sucesso",
  signInSuccessDescription: "Você foi autenticado com sucesso.",
  signInFailed: "Falha no login",
  signInError: "Erro ao fazer login",
  signOut: "Sair",
  showPassword: "Mostrar senha",
  hidePassword: "Esconder senha",
  noOrganization: {
    title: "Sem organização",
    description: "Você não faz parte de nenhuma organização. Entre em contato com um administrador para receber um convite.",
    signedInAs: "Conectado como"
  },
  login: {
    title: "Bem-vindo ao Prodgy",
    description: "Acesse sua conta para continuar",
    email: "E-mail",
    password: "Senha",
    signIn: "Entrar",
    orContinueWith: "Ou continue com",
    continueWithGoogle: "Continuar com Google",
    continueWithMicrosoft: "Continuar com Microsoft",
    forgotPassword: "Esqueceu a senha?",
    createAccount: "Criar conta",
    error: "Erro",
    missingCredentials: "Por favor, informe o e-mail e a senha",
    poweredBy: "Desenvolvido por"
  },
  signup: {
    title: "Crie sua conta",
    description: "Informe seu e-mail para começar no Prodgy",
    fields: {
      email: "E-mail",
      emailPlaceholder: "seu@email.com"
    },
    info: {
      title: "Configuração rápida e fácil",
      description: "Enviaremos um link de confirmação para completar seu cadastro"
    },
    buttons: {
      continue: "Continuar",
      backToLogin: "Voltar ao login"
    },
    orContinueWith: "Ou continue com",
    continueWithGoogle: "Continuar com Google",
    continueWithMicrosoft: "Continuar com Microsoft",
    validation: {
      emailRequired: "E-mail é obrigatório",
      emailInvalid: "Por favor, informe um e-mail válido"
    },
    success: {
      title: "Verifique seu e-mail!",
      description: "Enviamos um link de confirmação",
      message: "Por favor, verifique sua caixa de entrada e clique no link para completar seu cadastro. O link expira em 24 horas."
    },
    errors: {
      title: "Erro",
      generic: "Ocorreu um erro durante o cadastro. Por favor, tente novamente.",
      userExists: "Já existe uma conta com este e-mail",
      userExistsInline: "*Já existe usuário cadastrado com esse endereço",
      rateLimitExceeded: "Muitas tentativas. Por favor, tente novamente em {minutes} minutos",
      invalidEmail: "Formato de e-mail inválido"
    },
    alreadyHaveAccount: "Já tem uma conta?",
    signIn: "Entrar",
    agreeTermsStart: "Ao continuar, você concorda com nossos",
    agreeTermsMiddle: "e",
    agreeTermsEnd: ".",
    termsOfService: "Termos de Serviço",
    privacyPolicy: "Política de Privacidade"
  },
  onboarding: {
    profile: {
      title: "O prazer é todo nosso...",
      description: "Complete seu perfil para personalizar sua experiência",
      avatarLabel: "Foto de perfil (opcional)",
      avatarDescription: "Insira sua foto",
      firstNameLabel: "Nome",
      firstNamePlaceholder: "João",
      lastNameLabel: "Sobrenome",
      lastNamePlaceholder: "Silva",
      functionLabel: "Cargo/Função",
      functionPlaceholder: "Ex: Desenvolvedor, Gerente, Designer...",
      avatarSizeError: "Imagem muito grande. Tamanho máximo: 5MB",
      avatarUploadError: "Erro ao fazer upload da imagem. Tente novamente."
    },
    welcome: {
      title: "Bem-vindo ao Prodgy!",
      description: "Vamos configurar seu espaço de trabalho em apenas alguns passos",
      step1Title: "Criar sua conta",
      step1Description: "Você já completou esta etapa",
      step2Title: "Configurar sua organização",
      step2Description: "Crie seu espaço de trabalho para começar a usar o Prodgy"
    },
    organization: {
      title: "Mais Contexto, Menos Esforço",
      description: "A partir de agora você já começa a contextualizar seus agentes de IA ao máximo sobre seu negócio!",
      nameLabel: "Nome da organização",
      namePlaceholder: "Minha Empresa",
      nameDescription: "Este é o nome que sua equipe verá",
      industryLabel: "Setor/Indústria",
      industryPlaceholder: "Ex: Tecnologia, Saúde, Educação...",
      industryDescription: "Qual o setor de atuação da organização?",
      sizeLabel: "Tamanho da empresa",
      sizePlaceholder: "Selecione o tamanho",
      sizes: {
        "1-10": "1-10 funcionários",
        "11-50": "11-50 funcionários",
        "51-200": "51-200 funcionários",
        "201-500": "201-500 funcionários",
        "501-1000": "501-1000 funcionários",
        "1001-5000": "1001-5000 funcionários",
        "5000+": "5000+ funcionários"
      },
      stageLabel: "Estágio da empresa",
      stagePlaceholder: "Selecione o estágio",
      stages: {
        idea: "Ideia/Conceito",
        startup: "Startup",
        growth: "Em crescimento",
        established: "Estabelecida",
        enterprise: "Enterprise"
      },
      typeLabel: "Tipo de organização",
      typePlaceholder: "Selecione um tipo",
      typeDescription: "Escolha o tipo que melhor descreve sua organização",
      types: {
        personal: "Pessoal - Para uso individual",
        business: "Empresa - Para uso comercial"
      },
      infoLabel: "Descrição",
      infoPlaceholder: "Conte-nos sobre sua organização...",
      infoDescription: "Uma breve descrição da sua organização",
      websiteLabel: "Website",
      websitePlaceholder: "https://www.exemplo.com.br",
      websiteDescription: "Endereço do site da sua organização",
      websiteHelper: "Você pode digitar com ou sem https:// (ex: exemplo.com.br)",
      logoUpload: "Clique para adicionar um logo",
      logoDescription: "PNG, JPG ou SVG (recomendado: 512x512px)",
      logoSelected: "Logo selecionado",
      logoSizeError: "Imagem muito grande. Tamanho máximo: 5MB",
      logoUploadError: "Erro ao fazer upload da imagem. Tente novamente.",
      magicFillTooltip: "Preencher com IA",
      testingPrompt: "É só um teste e está sem ideias? Use o botão mágico para preencher ou complementar o formulário com IA.",
      magicFillIntroTitle: "Seu assistente mágico de preenchimento!",
      magicFillIntroBody: "Este é o botão de preenchimento automático com IA. Dentro do Prodgy ele vai estar sempre por perto, pronto pra acelerar seus cadastros com sugestões contextuais sempre que precisar."
    },
    steps: {
      profile: "Perfil",
      survey: "Informações",
      organization: "Organização",
      progress: "Passo {current} de {total}"
    },
    additionalInfo: {
      title: "Nos ajude a direcionar sua experiência!",
      description: "Informações adicionais nos ajudam a entender melhor suas necessidades",
      subtitle: "Isso nos ajuda a personalizar sua experiência",
      optional: "(opcional)",
      howFoundUs: {
        label: "Como você conheceu o Prodgy?",
        placeholder: "Selecione uma opção",
        options: {
          google: "Google/Busca",
          linkedin: "LinkedIn",
          referral: "Indicação de colega",
          social_media: "Redes sociais",
          blog: "Blog/Artigo",
          ad: "Anúncio",
          event: "Evento/Palestra",
          email: "Email marketing",
          other: "Outro"
        }
      },
      industry: {
        label: "Qual é o seu setor de atuação?",
        placeholder: "Selecione seu setor",
        options: {
          technology: "Tecnologia/Software",
          financial: "Financeiro/Fintech",
          healthcare: "Saúde",
          ecommerce: "E-commerce/Varejo",
          education: "Educação",
          manufacturing: "Indústria/Manufatura",
          marketing: "Marketing/Agências",
          legal: "Jurídico",
          construction: "Construção",
          food: "Alimentação/Restaurantes",
          services: "Serviços/Consultoria",
          other: "Outros"
        }
      },
      currentTools: {
        label: "Quais ferramentas você usa atualmente?",
        placeholder: "Selecione as ferramentas",
        description: "Selecione todas que se aplicam",
        options: {
          trello: "Trello",
          asana: "Asana",
          monday: "Monday.com",
          jira: "Jira",
          notion: "Notion",
          clickup: "ClickUp",
          excel: "Excel/Google Sheets",
          slack: "Slack",
          email: "Email/Gmail",
          zapier: "Zapier/Make",
          powerbi: "Power BI",
          teams: "Microsoft Teams",
          other: "Outras ferramentas"
        }
      },
      mainGoal: {
        label: "Qual é o seu principal objetivo com o Prodgy?",
        placeholder: "Ex: Automatizar processos repetitivos, melhorar colaboração da equipe, centralizar informações...",
        description: "Conte-nos em poucas palavras o que você espera alcançar"
      }
    },
    buttons: {
      back: "Voltar",
      continue: "Próximo passo →",
      finish: "Finalizar"
    },
    validation: {
      requiredField: "O campo {{field}} é obrigatório",
      requiredFieldsError: "* Existem campos obrigatórios não preenchidos.",
      firstNameMinLength: "O nome deve ter pelo menos 2 caracteres",
      firstNameMaxLength: "O nome pode ter no máximo 50 caracteres",
      lastNameMinLength: "O sobrenome deve ter pelo menos 2 caracteres",
      lastNameMaxLength: "O sobrenome pode ter no máximo 50 caracteres",
      functionMinLength: "O cargo/função deve ter pelo menos 2 caracteres",
      functionMaxLength: "O cargo/função pode ter no máximo 100 caracteres",
      nameMinLength: "O nome deve ter pelo menos 2 caracteres",
      nameMaxLength: "O nome pode ter no máximo 100 caracteres",
      typeRequired: "Selecione um tipo de organização",
      infoRequired: "A descrição da organização é obrigatória",
      websiteRequired: "O website da organização é obrigatório",
      websiteInvalid: "Por favor, informe uma URL válida (ex: https://exemplo.com.br)",
      industryMinLength: "O setor deve ter pelo menos 2 caracteres",
      industryMaxLength: "O setor pode ter no máximo 100 caracteres",
      sizeRequired: "Selecione o tamanho da empresa",
      stageRequired: "Selecione o estágio da empresa"
    },
    errors: {
      title: "Erro",
      generic: "Ocorreu um erro. Por favor, tente novamente.",
      createFailed: "Falha ao criar organização. Por favor, tente novamente.",
      subscriptionFailed: "Não foi possível criar a assinatura. Por favor, tente novamente ou entre em contato com o suporte.",
      paymentCheckFailed: "Não foi possível verificar o status do pagamento. Por favor, tente novamente ou entre em contato com o suporte."
    },
    autoFinish: {
      finishing: "Concluindo sua configuração...",
      errorDescription: "Não foi possível concluir seu onboarding. Verifique sua conexão e tente novamente.",
      retryButton: "Tentar novamente"
    }
  },
  waitlist: {
    title: "Acesso Restrito ao Trial",
    description: "Seu usuário não está inscrito na nossa lista de acesso antecipado para o plano Trial.",
    whatHappensTitle: "O que acontece agora?",
    step1: "Você será registrado na lista de espera",
    step2: "Receberá um email quando o acesso for liberado",
    step3: "Poderá acessar o Prodgy assim que for aprovado",
    requestButton: "Ingressar na lista de espera",
    footer: "Você será desconectado e notificado por email quando o acesso estiver disponível."
  },
  trial: {
    success: {
      title: "🎉 Trial Ativado!",
      description: "Seja bem-vindo! Seu período de trial foi ativado com sucesso.",
      validUntil: "Trial válido até",
      creditsAvailable: "Créditos disponíveis",
      message: "Aproveite todos os recursos do Prodgy durante o período de trial!",
      startButton: "Começar a Usar!"
    }
  },
  unsubscribe: {
    loading: {
      title: "Processando sua solicitação...",
      description: "Por favor, aguarde enquanto removemos você da nossa lista de emails"
    },
    success: {
      title: "Inscrição Cancelada com Sucesso",
      description: "Você não receberá mais emails relacionados a este convite.",
      message: "Lamentamos sua decisão. Se você mudou de ideia e deseja se juntar à nossa plataforma, ficaremos felizes em recebê-lo!",
      button: "Ir para o Login"
    },
    notFound: {
      title: "Convite Não Encontrado",
      description: "Este convite já foi removido ou o link está incorreto.",
      message: "O link de cancelamento pode já ter sido usado ou não está mais válido."
    },
    error: {
      title: "Erro ao Processar Solicitação",
      description: "Ocorreu um erro ao processar sua solicitação. Por favor, tente novamente mais tarde.",
      message: "Se o problema persistir, entre em contato com nossa equipe de suporte."
    }
  },
  oauth: {
    callback: {
      loading: "Autenticando...",
      validating: "Validando suas credenciais...",
      error: "Erro na autenticação",
      errorDescription: "Não foi possível completar a autenticação. Por favor, tente novamente."
    },
    consent: {
      title: "Autorizar aplicativo",
      description: "{{clientName}} quer acessar seu workspace no Prodgy.",
      requestedPermissions: "Permissões solicitadas",
      organization: "Organização",
      workspace: "Workspace",
      selectOrganization: "Selecione uma organização",
      selectWorkspace: "Selecione um workspace",
      authorize: "Autorizar",
      cancel: "Cancelar",
      disclaimer: "Você pode revogar este acesso depois. O token emitido ficará restrito à organização, ao workspace e às permissões escolhidas nesta tela.",
      scopeLabels: {
        "mcp_read": "Ler seus dados do Prodgy (MCP)",
        "mcp_write": "Criar e editar seus dados (MCP)",
        "mcp_execute": "Executar agentes e ações da plataforma (MCP)",
        "mcp_admin": "Gerenciar configurações avançadas (MCP)",
        "api_read": "Ler seus dados do Prodgy (API)",
        "api_write": "Criar e editar seus dados (API)",
        "api_execute": "Executar workflows, agentes e chat (API)",
        "api_admin": "Excluir recursos e gerenciar integrações (API)"
      },
      errors: {
        invalidRequest: "Solicitação de autorização inválida ou expirada.",
        loadFailed: "Não foi possível carregar a solicitação de autorização.",
        submitFailed: "Não foi possível concluir a autorização.",
        redirectFailed: "Não foi possível redirecionar para o aplicativo."
      }
    },
    error: {
      title: "Erro na Autenticação",
      accessDenied: "Autenticação cancelada. Tente novamente.",
      userCancelled: "Autenticação cancelada. Tente novamente.",
      authFailed: "Não foi possível completar a autenticação. Tente novamente.",
      genericError: "Ocorreu um erro durante a autenticação. Por favor, tente novamente.",
      emailMismatch: "O email da conta social não corresponde ao email do convite. Use a conta correta.",
      inviteExpired: "O link de convite expirou. Solicite um novo convite.",
      inviteInvalid: "O link de convite é inválido ou já foi utilizado.",
      pendingInvite: "Você tem um convite pendente para este email. Verifique sua caixa de entrada e aceite o convite para continuar.",
      backToLogin: "Voltar para Login",
      tryAgain: "Tentar Novamente"
    },
    connecting: "Conectando..."
  }
};
